import dayjs from "dayjs";

export class Dates {
  static isEmpty(dateString) {
    return !dateString || dateString == "0000-00-00";
  }

  static toDateBRL(dateString) {
    if (!dateString || !dayjs(dateString).isValid()) {
      return null;
    }

    if (dateString == "0000-00-00") {
      return "00/00/0000";
    }

    return dayjs(dateString).format("DD/MM/YYYY");
  }

  static toDateTimeBRL(dateString) {
    return dayjs(dateString).format("DD/MM/YYYY HH:mm");
  }

  static toTimeBRL(dateString, seconds = false) {
    return dayjs(dateString).format(seconds ? "HH:mm:ss" : "HH:mm");
  }

  static unformat(dateString) {
    return dayjs(dateString, "DD/MM/YYYY").format("YYYY-MM-DD");
  }
}
